import { render, staticRenderFns } from "./_workFloGeneralMarketing.vue?vue&type=template&id=5163cccc&scoped=true&"
import script from "./_workFloGeneralMarketing.vue?vue&type=script&lang=js&"
export * from "./_workFloGeneralMarketing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5163cccc",
  null
  
)

export default component.exports